import React from "react";
import PageHeader from "../../components/PageHeader";
import TeamMemberListComponent from "../../components/TeamMembers/TeamMemberList";

class TeamMemberList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Team Members"
                            Breadcrumb={[
                                { name: "Team Members", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <TeamMemberListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamMemberList;
